import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

//

// @ts-ignore

@Component({
    selector: 'app-pdf-test',
    templateUrl: './pdf-test.component.html',
    styleUrls: ['./pdf-test.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PdfTestComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  async pdfPicked(event: Event) {
    const firstNames = (await fetch('/assets/nls/firstNames/pl.json').then(
      (r) => r.json(),
    )) as string[];

    // @ts-ignore
    pdfjsLib.GlobalWorkerOptions.workerSrc =
      'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';
    // @ts-ignore
    const file = event.target.files[0];

    const fileReader = new FileReader();

    fileReader.onload = async (res) => {
      const typedarray = new Uint8Array(res.target.result as ArrayBuffer);

      // @ts-ignore
      const loadingTask = await pdfjsLib.getDocument(typedarray).promise;
      console.log(loadingTask);
      const page = await loadingTask.getPage(1);
      const text = await page.getTextContent();
      console.log(text);
      const groupByTransformFifthIndex = text.items.reduce(
        (acc, item, index) => {
          if (typeof acc[item.transform[4]] === 'undefined') {
            acc[item.transform[4]] = [];
          }

          acc[item.transform[4]].push(item);
          return acc;
        },
        {} as Record<string, { str: string; transform: number[] }[]>,
      ) as {} as Record<string, { str: string; transform: number[] }[]>;
      const maxArrayLength = Math.max(
        ...Object.values(groupByTransformFifthIndex).map((arr) => arr.length),
      );
      console.log(maxArrayLength);

      const maxSizeArrays = Object.values(groupByTransformFifthIndex).filter(
        (arr) => arr.length === maxArrayLength,
      );
      const maxSizedArraysWithNames = maxSizeArrays.filter((ar) =>
        ar.some((a) => firstNames.some((fName) => a.str.includes(fName))),
      );
      const maxSizedArraysDistances = maxSizedArraysWithNames.reduce(
        (acc, arr, i) => {
          arr.forEach((item, i2, arr) => {
            if (i2 !== 0) {
              if (typeof acc[i] === 'undefined') {
                acc[i] = {};
              }
              const index = Math.abs(
                Math.floor(arr[i2 - 1].transform[5] - item.transform[5]),
              );
              if (typeof acc[i][index] === 'undefined') {
                acc[i][index] = 0;
              }
              acc[i][index]++;
            }
          });
          return acc;
        },

        {} as Record<number, Record<number, number>>,
      );
      console.log(maxSizedArraysDistances);
      const mostPopularDistances = Object.values(maxSizedArraysDistances).map(
        (arr) => {
          const max = Math.max(...Object.values(arr));
          return Object.entries(arr).find(([key, value]) => value === max)[0];
        },
      );
      console.log(mostPopularDistances);

      console.log(
        maxSizedArraysWithNames.map((el, i) => {
          const content = [];
          const mostPopularDistance = Number(mostPopularDistances[i]);
          el.forEach((item, i, arr) => {
            if (i !== 0) {
              const index = Math.abs(
                Math.floor(arr[i - 1].transform[5] - item.transform[5]),
              );
              if (index < mostPopularDistance) {
                content[content.length - 1] =
                  content[content.length - 1] + ' ' + item.str;
              } else {
                content.push(item.str);
              }
            } else {
              content.push(item.str);
            }
          });
          return content;
        }),
      );
    };
    fileReader.readAsArrayBuffer(file);
  }
}
